module.exports = __webpack_public_path__ + "static/media/cerrarsesion_white.4a02fafa.svg";